import { Component } from '@angular/core';

@Component({
  selector: 'app-collect-payment',
  standalone: true,
  imports: [],
  templateUrl: './collect-payment.component.html',
  styleUrl: './collect-payment.component.css'
})
export class CollectPaymentComponent {

}
